import { Box, styled, Typography } from '@mui/material'

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;
  height: 48px;
  padding: 0 4px;
  width: 100%;
`

export const Value = styled(Typography)`
  font-size: 13px;
  font-weight: 400;
  line-height: 15px;
  text-align: right;
  color: ${({ theme }) => theme.palette.custom.gray2};

  .highlight & {
    color: ${({ theme }) => theme.palette.custom.green1};
  }
`
